import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { REVIEWS } from '../mock';

export default function ReviewsSection() {
  return (
    <section className="bg-[#FDF3EC] py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="eyebrow uppercase mb-3">Customers Love us on Google</div>
          <h2 className="section-title text-3xl md:text-5xl mb-4">Real Reviews from Real Foodies</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">We’re proud to be one of Port Coquitlam’s local favorites. But don’t just take our word for it — see what our amazing customers are saying:</p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-10">
          <div className="bg-white rounded-2xl px-6 py-4 shadow-sm flex items-center gap-4">
            <div className="text-left">
              <div className="text-xs text-gray-500">EXCELLENT</div>
              <div className="flex text-[#F5A623]">
                {[1,2,3,4,5].map(i => <Star key={i} size={18} fill="#F5A623" strokeWidth={0} />)}
              </div>
              <div className="text-xs text-gray-500 mt-1">Based on 15 reviews</div>
            </div>
          </div>
          <a href="https://g.page/r/CW4C8UfHAEFTEAE/review" target="_blank" rel="noopener noreferrer" className="btn-wrappus text-sm">
            Write a Review <ExternalLink size={14} />
          </a>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.slice(0, 6).map((r, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-shadow">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-[#ED2E2E] text-white flex items-center justify-center font-bold">{r.name[0]}</div>
                <div>
                  <div className="font-semibold text-[#0F1C2E]">{r.name}</div>
                  <div className="text-xs text-gray-500">Posted on Google</div>
                </div>
              </div>
              <div className="flex text-[#F5A623] mb-2">
                {[1,2,3,4,5].map(i => <Star key={i} size={14} fill="#F5A623" strokeWidth={0} />)}
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
